export default __webpack_public_path__ + "static/media/uploadImgBtn.e86c7dfb.svg";